<section class="no-results-container">
  {{ noContentText || null }}
  <div><img src="../../../assets/images/icons/nolist.svg" alt="" /></div>
</section>
